import { z } from "zod";
import { richMenuTemplateSchema } from "./richmenu.schemas";

/**
 * =============================================================================
 * GET /richmenus/templates API SCHEMAS
 * =============================================================================
 */

/**
 * Standard API success response base structure
 */
export const ApiSuccessResponseBaseSchema = z.object({
	message: z.string(),
	success: z.literal(true),
});

/**
 * Standard API error response base structure
 */
export const ApiErrorResponseBaseSchema = z.object({
	message: z.string(),
	success: z.literal(false),
	details: z.any().optional(),
});

/**
 * @description A list of available rich menu templates organized by size
 */
export const getRichMenuTemplates200Schema =
	ApiSuccessResponseBaseSchema.extend({
		data: z.object({
			compact: z.array(richMenuTemplateSchema),
			large: z.array(richMenuTemplateSchema),
		}),
	}).strict();

/**
 * @description Not found
 */
export const getRichMenuTemplates404Schema = z.lazy(
	() => ApiErrorResponseBaseSchema,
);

/**
 * @description Internal server error
 */
export const getRichMenuTemplates500Schema = z.lazy(
	() => ApiErrorResponseBaseSchema,
);

// Convenience aliases
export const getRichMenuTemplatesQueryResponseSchema = z.lazy(
	() => getRichMenuTemplates200Schema,
);
